import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

export function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuthStore();
  const location = useLocation();
  const isSurveyPath = window.location.hostname === 'sondage.cs-expo1.fr';

  // Allow access to survey subdomain without authentication
  if (isSurveyPath) {
    return <>{children}</>;
  }

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    // Save the attempted URL for redirection after login
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // Check if user has required role for admin routes
  if (location.pathname.startsWith('/admin') && !['admin', 'council'].includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}